<style scoped lang="scss">
	/* #ifdef APP */
	.top-box {
		padding-top: calc( env(safe-area-inset-top) + 80px );
	}
	/* #endif */
	/* #ifdef H5 */
	.top-box {
		padding-top: env(safe-area-inset-top);
	}
	/* #endif */
	.myNav {
		padding: 30px 20px 20px 20px;
		display: flex;
		flex-direction: row;
		align-items: center;
		.lottery_name {
			font-weight: bold;
			font-size: 38px;
			margin-left: 20px;
		}
	}
	.preview {
		text-align: center;
		margin-top: 10px;
		font-size: 15px;
		color: #333333;
		.num {
			color: #EB4C37;
			margin: 0 10px;
		}
	}
	
	.cancel-box {
		margin: 20px;
		background-color: white;
		border-radius: 20px;
		padding: 40px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		.downtime {
			display: flex;
			flex-direction: row;
			align-items: center;
			.t {
				background-color: #555555;
				border-radius: 10px;
				color: white;
				padding: 6px 16px;
				margin: 0 6px;
			}
			.p {
				font-weight: bold;
				margin: 0 4px;
			}
		}
		.cancel-btn {
			margin-top: 30px;
			border-radius: 20px;
			padding: 10px 30px;
			background-color: #EB4C37;
			color: white;
		}
	}
	.ticket-box {
		display: flex; flex-direction: row;
		flex-wrap: wrap;
		.upload {
			position: relative;
			overflow: hidden;
			margin-right: 26px;
			margin-bottom: 10px;
			width: 100px;
			height: 100px;
			border: solid 1px #cccccc;
			border-radius: 10px;
			display: flex; flex-direction: row; align-items: center; justify-content: center;
			.close {
				position: absolute;
				right: 0;
				top: 0;
				width: 50px;
				height: 50px;
				display: flex;
				flex-direction: row;
				align-items: flex-start;
				justify-content: flex-end;
				z-index: 500;
			}
		}
		.ticket {
			width: 100%;
			height: 100%;
		}
	}
	.order-detail {
		margin: 20px;
		border-radius: 20px;
		background-color: white;
		font-size: 16px;
		.header {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			height: 30px;
			background-color: #f1f1f1;
			padding-left: 10px;
		}
		.form {
			.line {
				height: 30px;
				padding: 0 10px;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				border-bottom: dashed 1px #dcdcdc;
				.key {
					color: #888888;
				}
				.value {
					color: #333333;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
				}
			}
		}
	}
	.op-box {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-top: 20px;
		.op-btn {
			font-size: 12px;
			color: #3399ff;
			border: solid 2px #3399ff;
			border-radius: 16px;
			padding: 6px 20px;
		}
	}
	.footer {
		z-index:501;
		border-radius: 67px 67px 0px 0px;
		width: 630px;
		position: fixed;
		bottom: 0;
		background-color: white;
		box-shadow: 0 0 0 2px #EFEFEF;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding-left: 60px;
		padding-right: 60px;
		padding-top: 40px;
		padding-bottom: 40px;
		.btn {
			background: #3399ff;
			width: 260px;
			height: 70px;
			border-radius: 38px;
			text-align: center;
			line-height: 70px;
			color: white;
			margin-bottom: 10px;
			
		}
		.btn-white {
			border: solid 1px #3399ff;
			color: #3399ff;
			width: 260px;
			height: 70px;
			border-radius: 38px;
			text-align: center;
			line-height: 70px;
			margin-bottom: 10px;
		}
		.btn-red {
			background: #fa3534;
			width: 260px;
			height: 70px;
			border-radius: 38px;
			text-align: center;
			line-height: 70px;
			color: white;
			margin-bottom: 10px;
		}
	}
</style>
<template>
	<div>
		<div class="order-card" v-if="detail">
			<div class="card-item">
				<div>
					<div class="amount">{{detail.orderAmount}}元</div>
					<div class="tag">方案金额</div>
				</div>
			</div>
			<div class="card-item">
				<div>
					<div class="status" style="color: #FFFFFF;" v-if="detail.orderStatus == 0 || detail.orderStatus == 1">待出票</div>
					<div class="status" style="color: #FFFFFF;" v-if="detail.orderStatus == 2">待开奖</div>
					<div class="status" style="color: #ff9900;" v-if="detail.orderStatus == 3">待派奖</div>
					<div class="status" style="color: #18b566;" v-if="detail.orderStatus == 4">未中奖</div>
					<div class="status" style="color: #fa3534;" v-if="detail.orderStatus == 5">已派奖</div>
					<div class="status" style="color: #FFFFFF;" v-if="detail.orderStatus == 7">已取票</div>
					<div class="status" style="color: #FFFFFF;" v-if="detail.orderStatus == 6">已撤单</div>
					<div class="tag">方案状态</div>
				</div>
			</div>
			<div class="card-item">
				<div>
					<div class="award" v-if="detail.orderStatus == 3 || detail.orderStatus == 5">{{detail.award}}</div>
					<div class="award" v-if="detail.orderStatus != 3 && detail.orderStatus != 5">-</div>
					<div class="tag">税后奖金</div>
				</div>
			</div>
		</div>
		
		
		
		<div class="order-info"  v-if="detail">
			<div class="title-box">
				<div class="left">
					<img class="logo" :src="detail.lotteryIcon" />
					<div class="name">{{detail.lotteryName}}</div>
					<div class="play" v-if="detail.playType != ''">({{detail.playType}})</div>
				</div>
			</div>
			<div class="tags-line">
				<div class="tags mul" v-if="detail.lotterySign!='football' && detail.lotterySign!='basketball'">{{detail.issue}}期</div>
				<div class="tags count" v-if="detail.matchCount!=0">{{detail.matchCount}}场</div>
				<div class="tags pass" v-if="detail.passList!=''">{{detail.passList}}</div>
				<div class="tags mul" v-if="detail.lotterySign=='football' || detail.lotterySign=='basketball' || detail.lotterySign=='peking'">{{detail.betCount}}注/{{detail.multiplier}}倍/{{detail.ticket_count}}张</div>
				<div class="tags mul" v-else>{{detail.betCount}}注<span v-if="detail.multiplier!=0">/{{detail.multiplier}}倍</span></div>
				
				
				<div class="tags count" v-if="detail.is_fadan != 0 || detail.is_follow != 0 || detail.is_union != 0">
					<span v-if="detail.is_fadan == 1">发单</span>
					<span v-if="detail.is_follow == 1">跟单</span>
					<span v-if="detail.is_union == 1">合买</span>
				</div>
				
				<div class="tags count" v-if="detail.optimize_type != 0">
					<span v-if="detail.optimize_type == 1">平均优化</span>
					<span v-if="detail.optimize_type == 2">博热优化</span>
					<span v-if="detail.optimize_type == 3">博冷优化</span>
				</div>
			</div>
			
			<div class="table">
				<jcTable v-if="['football', 'basketball', 'peking'].includes(detail.lotterySign)" style="border: solid 2px #dcdcdc;" :matchList="detail.matchList" :lotterySign="detail.lotterySign"></jcTable>
				<winloseTable v-if="['any9', 'winlose'].includes(detail.lotterySign)" style="border: solid 2px #dcdcdc;" :matchList="detail.matchList"></winloseTable>
				<jqcTable v-if="['jqc', 'bqc'].includes(detail.lotterySign)" style="border: solid 2px #dcdcdc;" :matchList="detail.matchList" :lotterySign="detail.lotterySign"></jqcTable>
				<luckyTable v-if="detail.lotterySign == 'biglucky'" style="border: solid 2px #dcdcdc;" :matchList="detail.matchList"></luckyTable>
				<starTable v-if="detail.lotterySign == '7star'" style="border: solid 2px #dcdcdc;" :matchList="detail.matchList"></starTable>
				<sort5 v-if="detail.lotterySign == 'sort5'" style="border: solid 2px #dcdcdc;" :matchList="detail.matchList"></sort5>
				<sort3 v-if="detail.lotterySign == 'sort3'" style="border: solid 2px #dcdcdc;" :matchList="detail.matchList"></sort3>
				
				<div class="preview" v-if="detail.previewAward != ''">预计中奖金额<span class="num">{{detail.previewAward}}</span> 元</div>
			<!-- 	<div class="op-box"  v-if="detail.lotterySign=='football' || detail.lotterySign=='basketball' || detail.lotterySign=='peking'">
					<div class="op-btn" @click="viewPrintDetail()">
						查看拆票明细
					</div>
				</div> -->
			</div>
		</div>
		
		<div  class="notice" v-if="detail">
			<div class="title">票据<span style="color: orangered;" v-if="detail.must_ticket == 0">（用户未要求上传）</span></div>
			
			<div class="ticket-box">
				<div class="upload" v-for="(item, index) in detail.tickets" :key="index">
					<el-image :src="item" :preview-src-list="[item]" lazy style="border-radius: 2px; width: 100px; height: 100px;"></el-image>
				</div>
				
			</div>
		</div>
		
		<div class="order-detail" v-if="detail">
			<div class="header">
				<div class="title">订单信息</div>
			</div>
			<div class="form" v-show="ticketDetail">
				<div class="line">
					<div class="key">下单用户</div>
					<div class="value" @click="goPage('/user/detail?uid=' + detail.downUser.uid)">
						<div>{{detail.downUser.nickname}}<span v-if="detail.downUser.remark!=''">({{detail.downUser.remark}})</span></div>
					</div>
				</div>
				<div class="line">
					<div class="key">接单人</div>
					<div class="value" @click="changeRev()">
						<div>{{detail.revUser}}</div>
					</div>
				</div>
				<div class="line">
					<div class="key">派单店铺</div>
					<div class="value">
						<div>{{detail.revShopName}}</div>
					</div>
				</div>
				<div class="line">
					<div class="key">方案编号</div>
					<div class="value">
						<div>{{detail.orderSn}}</div>
					</div>
				</div>
				<div class="line" v-if="detail.orderStatus == 6">
					<div class="key">撤单原因</div>
					<div class="value">{{detail.cancel_reason}}</div>
				</div>
				<div class="line">
					<div class="key">方案投注时间</div>
					<div class="value">{{formatTimestamp(detail.downTime)}}</div>
				</div>
				<div class="line">
					<div class="key">方案截止时间</div>
					<div class="value">{{formatTimestamp(detail.userStopTime)}}</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import jcTable from './tables/jcTable.vue';
	import winloseTable from './tables/winloseTable.vue';
	import jqcTable from './tables/jqcTable.vue';
	import starTable from './tables/starTable.vue';
	import luckyTable from './tables/luckyTable.vue';
	import sort5 from './tables/sort5.vue';
	import sort3 from './tables/sort3.vue';
	export default {
		props:['orid'],
		components:{
			jcTable, winloseTable, jqcTable, luckyTable, starTable, sort5, sort3
		},
		data() {
			return {
				getTicketShow:false,
				newAward:'',
				editAwardShow:false,
				alertShow:false,
				awardType:'',
				alertContent:'',
				canCancel: false,
				timer:null,
				detail:null,
				time:{
					m1:0,
					m2:0,
					s1:0,
					s2:0
				},
				ticketDetail:true,
				staffList:[],
				
				cancelShow:false,
				cancelTextList:[
					'订单逾期', '票数太多', '订单较多，忙不过来', '联系不到客户', '中心限制订单，无法出票', '来不及出票，赔率变化', '自定义'
				],
				cancelForm:{
					check_key:0,
					defineCancelReason:'',
				}
			}
		},
		created() {
			console.log(this.orid);
			this.getDetail();
		},
		onUnload() {
			clearInterval(this.timer);
		},
		methods: {
			viewPrintDetail(){
				uni.navigateTo({
					url:'/pages/order/printOrderDetail?orid=' + this.orid
				})
			},
			copy(_content){
				uni.setClipboardData({
					data: _content,
					success: () => {
						uni.showToast({
							title: '复制成功',
							icon: 'none'
						})
					}
				})
			},
			previewPhoto(_url){
				uni.previewImage({
					urls:[_url]
				})
			},
			downTimeFunc(){
				let _now = Math.floor( new Date().getTime() / 1000);
				let _sub = this.detail.canCancelTime - _now;
				if(_sub <= 0){
					this.canCancel = false;
					clearInterval(this.timer);
				}else{
					let _sec = _sub % 60;
					let _min = Math.floor(_sub / 60);
					this.time.m1 = Math.floor( _min / 10 );
					this.time.m2 = _min % 10;
					this.time.s1 = Math.floor( _sec / 10 );
					this.time.s2 = _sec % 10;
				}
			},
			actionDownTime(){
				if(this.detail.orderStatus == 0 && this.detail.canCancelTime*1000 > (new Date()).getTime()){
					this.canCancel = true;
					this.timer = setInterval( this.downTimeFunc, 1000);
				}else{
					this.canCancel = false;
					clearInterval(this.timer);
					
				}
			},
			getDetail(){
				let _this = this;
				_this.$api.post("/Order/getOrderDetail", {orid: _this.orid}, {token:true}).then(res=>{
					if(res.code == 200){
						_this.detail = res.data;
						_this.actionDownTime();
					}
				}).catch(err=>{
				})
			},
			back(){
				uni.navigateBack();
			},
			formatTimestamp(ts) {
				// 如果是 10 位（秒），需要乘 1000 变成毫秒
				if (ts.toString().length === 10) {
					ts *= 1000
				}
				const date = new Date(ts)

				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')

				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')

				return `${Y}-${M}-${D} ${h}:${m}:${s}`
			}
		}
	}
</script>

<style>
	page {
		background-color: #F6F6F6;
	}
</style>
<style scoped lang="scss">
	page {
		background-color: #F6F6F6;
	}
	.notice {
		margin: 10px;
		padding: 10px;
		background-color: white;
		border-radius: 10px;
		.title {
			font-weight: bold;
			font-size: 14px;
			margin-bottom: 10px;
		}
		.line {
			margin-bottom: 4px;
			color: #888888;
			font-size: 14px;
		}
	}
	.order-info {
		margin: 10px;
		padding: 10px;
		background-color: white;
		border-radius: 10px;
		.title {
			font-weight: bold;
			font-size: 15px;
			margin-bottom: 10px;
		}
		.title-box {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			margin: 5px 0 20px 0;
			.left {
				display: flex;
				flex-direction: row;
				align-items: center;
				.logo {
					margin-right: 10px;
					height: 25px;
				}
				.name {
					font-weight: bold;
					font-size: 17px;
					margin-right: 5px;
				}
				.play {
					font-size: 13px;
					color: #999999;
				}
			}
			.right {
				display: flex;
				flex-direction: row;
				align-items: center;
				
				.time {
					margin-right: 5px;
					font-size: 15px;
					color: orangered;
				}
				.tip {
					font-size: 15px;
					color: #999999;
				}
			}
		}
		.tags-line {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			margin-bottom: 5px;
			.tags {
				margin-right: 10px;
				padding: 3px 7px;
				font-size: 13px;
				border-radius: 5px;
				margin-bottom: 5px;
			}
			.count {
				color: #6A54B9;
				background-color: #D2CBEA;
			}
			.mul {
				color: #EB4C37;
				background: #F9C9C3;
			}
			.pass {
				color: #55B2AA;
				background-color: #CCE7E5;
			}
		}
	}
	.order-card {
		margin: 10px;
		padding: 15px 50px;
		border-radius: 10px;
		background-color: #F8DBCF;
		background: linear-gradient(to bottom right, #5372E7, #21BDCA);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		.card-item {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			width: 112px;
			.icon {
				width: 19px;
				margin-right: 7px;
			}
			.amount {
				line-height: 27px;
				color: white;
				font-weight: bold;
				font-size: 17px;
			}
			.status {
				line-height: 27px;
				font-weight: bold;
				font-size: 17px;
			}
			.award {
				line-height: 27px;
				font-weight: bold;
				font-size: 17px;
				color: #EB4C37;
			}
			.tag {
				line-height: 15px;
				font-size: 12px;
				color: #401000;
				opacity: 0.6;
			}
		}
	}
	.showBox {
		padding: 20px 20px 25px 20px;
		.showTitle {
			font-weight: bold;
			font-size: 15px;
			color: #333333;
			margin-bottom: 15px;
		}
		.btn-box {
			margin-top: 15px;
			display: flex; flex-direction: row; align-items: center;
			.cancel {
				background-color: #F0F0F0;
				width: 100px;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-radius: 10px;
				font-size: 14px;
				margin-right: 15px;
			}
			.confirm {
				background-color: orangered;
				width: 250px;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-radius: 10px;
				font-size: 14px;
				color: white;
			}
		}
		.select-box {
			display: flex; flex-direction: row; align-items: center; justify-content: space-between;
			background-color: #F0F0F0;
			padding: 5px 20px;
			border-radius: 15px;
			margin-bottom: 15px;
			.select-txt {
				font-size: 13px;
				color: #333333;
			}
			.select-mark {
				width: 20px;
				height: 20px;
				border-radius: 25px;
				background-color: #DCDCDC;
				display: flex; flex-direction: row; align-items: center; justify-content: center;
			}
			.mark {
				background-color: #21BDCA;
			}
		}
	}
</style>
